<template>
  <a-spin :spinning="confirmLoading">
    <a-divider orientation="left">
      {{ $t('用户信息') }}
    </a-divider>
    <detail-list>
      <detail-list-item :term="$t('用户编号')">{{model.userId}}</detail-list-item>
      <detail-list-item :term="$t('用户姓名')">{{model.userName}}</detail-list-item>
      <detail-list-item :term="$t('用户手机号')">{{model.userPhone}}</detail-list-item>
      <detail-list-item :term="$t('表安装地址')">{{model.userMeterAddr}}</detail-list-item>
      <detail-list-item :term="$t('用户地址')" style="width: 66.66%;" v-if="model.userAreaName">{{model.userAreaName.slice(model.userAreaName.indexOf('-')+1,model.userAreaName.length)+'-'+model.userAddr}}</detail-list-item>
      <detail-list-item :term="$t('用户地址')" style="width: 66.66%;" v-else>{{model.userAddr}}</detail-list-item>
    </detail-list>
    <a-divider orientation="left">
      {{ $t('旧表信息') }}
    </a-divider>
    <detail-list>
      <detail-list-item :term="$t('旧表编号')">{{model.meterIdOld}}</detail-list-item>
      <detail-list-item :term="$t('旧表结算累积流量(m³)')">{{model.meterOldSumFlowAfterChange}}</detail-list-item>
      <detail-list-item :term="$t('旧表结算剩余金额(元)')">{{model.meterRemianMoney}}</detail-list-item>
      <detail-list-item :term="$t('旧表机械读数(m³)')">{{model.meterOldMachineReadingNum}}</detail-list-item>
      <detail-list-item :term="$t('是否以旧表机械读数结算')">{{model.meterChangeChargeType == 1?$t('是'):$t('否')}}</detail-list-item>
    </detail-list>
    <detail-list>
      <a-divider orientation="left">
        {{ $t('新表信息') }}
      </a-divider>
      <detail-list-item :term="$t('新表编号')">{{model.meterIdNew}}</detail-list-item>
      <detail-list-item :term="$t('新表起始读数(m³)')">{{model.meterStartNum}}</detail-list-item>
    </detail-list>
    <detail-list>
      <a-divider orientation="left">
        {{ $t('换表信息') }}
      </a-divider>
      <detail-list-item :term="$t('换表原因')" :itemCol="2">{{setmeterChangeType()}}</detail-list-item>
      <detail-list-item :term="$t('换表结算剩余金额(元)')" :itemCol="2">{{model.meterUserAccountNumAfterChange}}</detail-list-item>
      <!--
      <detail-list-item term="换表结算累计流量(m³)">{{model.meterOldSumFlowAfterChange}}</detail-list-item>
      -->
      <detail-list-item :term="$t('换表原因描述')" :itemCol="1">{{model.meterChangeReason}}</detail-list-item>
      <detail-list-item :term="$t('操作时间')" :itemCol="2">{{model.createTime}}</detail-list-item>
      <detail-list-item :term="$t('操作人')" :itemCol="2">{{model.createBy}}</detail-list-item>
    </detail-list>
  </a-spin>
</template>
<script>
  import { httpAction, getAction } from '@/api/manage'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item

  export default {
    name: 'MeteChangeMeterRecordForm',
    components: {
      DetailList,
      DetailListItem
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    filters: {
      filterDictTextByCache
    },
    data () {
      return {
        confirmLoading: false,
        model: {},
        validatorRules: {
        },
        url: {
        },
      }
    },
    computed: {
      // i18n：换表原因选项映射使用 computed 以响应语言切换
      meterChangeTypeList() {
        return {
					0:this.$t('周期性换表'),
					1:this.$t('故障换表'),
					2:this.$t('故障换表/基表问题'),
					3:this.$t('故障换表/基表问题/计量问题'),
					4:this.$t('故障换表/基表问题/阀门故障'),
					5:this.$t('故障换表/基表问题/基表爆裂'),
					6:this.$t('故障换表/电子问题'),
					7:this.$t('故障换表/电子问题/不上传数据'),
					8:this.$t('故障换表/电子问题/水表无反应(黑屏、无法激活)'),
					9:this.$t('故障换表/磁干扰'),
					10:this.$t('故障换表/缺电'),
					11:this.$t('故障换表/其他'),
				}
      },
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      setmeterChangeType(){
        // return filterDictTextByCache('meterChangeType',this.model.meterChangeType);
        return this.meterChangeTypeList[this.model.meterChangeType];
      }
    }
  }
</script>

<style scoped>
.detail-list >>> .content{
  line-height: normal;
}
</style>